export type DeprecatedVariant<T extends readonly string[]> = T[number];

export type DeprecatedVariantProps<T extends readonly string[]> = {
	[K in T[number]]?: boolean;
};

export function convertDeprecatedVariant<TVar extends readonly string[]>(
	variants: TVar,
	props: DeprecatedVariantProps<TVar>
): TVar[number] | undefined {
	for (const v of variants) {
		if (props[v] === true) {
			return v;
		}
	}

	return undefined;
}
